function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#19A784",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31.993,
  cy: 31.993,
  r: 31.295,
  fill: "#E2F4EF",
  strokeWidth: 1.397
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.78 40.123)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.705,
  cy: 11.705,
  r: 11.705,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19A784",
  fillRule: "nonzero",
  strokeWidth: 0.5,
  d: "M18.972 6.46c-.3-.29-.783-.29-1.082 0L8.73 15.371l-3.522-3.425c-.299-.29-.783-.29-1.081 0-.3.29-.3.761 0 1.052l4.062 3.951c.298.29.783.29 1.081 0l9.703-9.437c.298-.29.298-.761 0-1.052z"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M48.2 18v12h-5v13h-8l-1-4 2-2-1-2-1-1h-8v-3h-5V19l2-3h5l2 4 4 2 5-2 2-4h5l2 2z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#19A784",
  strokeWidth: 1.3,
  transform: "translate(18.2 16)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.236 14.836h5.55v-11.1c0-2.043-1.656-3.7-3.7-3.7h-3.792c-.448 3.181-3.17 5.547-6.383 5.547S7.976 3.217 7.53.036H3.736c-2.043 0-3.7 1.657-3.7 3.7v11.1h5.55",
  transform: "translate(2.533)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.586 9.286L5.586 27.786 22.236 27.786 22.236 9.286",
  transform: "translate(2.533)"
})), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 18.194,
  fill: "#FFF",
  rx: 2.294
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 23.128,
  fill: "#FFF",
  rx: 2.294
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 28.061,
  fill: "#FFF",
  rx: 2.294
})));

function SvgFolding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolding);
export default __webpack_public_path__ + "static/media/folding.41de60fe.svg";
export { ForwardRef as ReactComponent };